import { type Interceptor } from '@connectrpc/connect';
import { settingsQueryKey } from '@/api/query-keys';
import { type SettingsDto } from '@/api/services/settings';
import { ctxKeyQueryClient } from '@/connect-query/context-keys';
import { missingQueryFnHandler } from '../missing-query-fn';

const QdVersionRegex = /(?:[0-9]{1,5}\.[0-9]{1,5}\.[0-9]{1,5})/;

/**
 * Connect Query interceptor to add app version (`X-Qd-Version`) header to all gRPC requests.
 */
export const appVersionInterceptor: Interceptor = (next) => async (req) => {
  const queryClient = req.contextValues.get(ctxKeyQueryClient);
  const { tag } = await missingQueryFnHandler(queryClient.ensureQueryData<SettingsDto>({ queryKey: settingsQueryKey }));
  if (QdVersionRegex.test(tag)) {
    req.header.append('X-Qd-Version', tag);
  }
  return next(req);
};
